import type { DeviationEnum, WorkOrderPriceStatusEnum } from 'gql/graphql';

export enum WorkOrderPriceTypeEnum {
    COEFFICIENT = 'COEFFICIENT',
    CONSTRAINT_COEFFICIENT = 'CONSTRAINT_COEFFICIENT',
    MTR = 'MTR',
    MTR_CONTRACTOR_EQUIPMENT = 'MTR_CONTRACTOR_EQUIPMENT',
    MTR_CONTRACTOR_MATERIAL = 'MTR_CONTRACTOR_MATERIAL',
    MTR_CUSTOMER_EQUIPMENT = 'MTR_CUSTOMER_EQUIPMENT',
    MTR_CUSTOMER_MATERIAL = 'MTR_CUSTOMER_MATERIAL',
    TECH_PART_COEFFICIENT = 'TECH_PART_COEFFICIENT',
    UER = 'UER',
    OTHERS = 'OTHERS',
    OTHERS_NEW = 'OTHERS_NEW',
}

export type WorkOrderPriceListItem = {
    code: string;
    name: string;
    type: WorkOrderPriceTypeEnum;
    status: WorkOrderPriceStatusEnum;
    isActKC2Price: boolean;
    totalPlanVolume: number;
    totalPlanCost: number;
    totalCompletedCost: number;
    totalCompletedVolume: number;
    totalRemainderCost: number;
    totalRemainderVolume: number;
};

export type WorkOrderActKC2PriceData = {
    acceptedCost: number;
    acceptedVolume: number;
    actKC2Id: number;
    id: number;
    planCost: number;
    planVolume: number;
    acceptedVolumeDeviation: DeviationEnum;
    planVolumeDeviation: DeviationEnum;
};

export enum WorkOrderChapters {
    CHAPTER1_7 = 'CHAPTER1_7',
    CHAPTER8 = 'CHAPTER8',
    CHAPTER9 = 'CHAPTER9',
    OTHERS = 'OTHERS',
    SUMMARY = 'SUMMARY',
}

export enum AddRatioToActKc2StrategyEnum {
    CORRECT_ORIGINAL = 'CORRECT_ORIGINAL',
    DUPLICATE_WITH_EXTENDED_COEFFICIENTS = 'DUPLICATE_WITH_EXTENDED_COEFFICIENTS',
}

export type Row = Partial<WorkOrderPriceListItem>;

// TODO: !!!! проверить все типы и удалить этот файл, если не нужны, сейчас все корректные типы есть в gql
